var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.129)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.8745,
    y1: 16.5169,
    x2: 21.4137,
    y2: 3.9778,
    gradientTransform: "matrix(3.7037 0 0 3.7037 -1.3993 4.7281)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    style: {
      stopColor: "#C757BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    style: {
      stopColor: "#CD5CA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    style: {
      stopColor: "#E8744F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    style: {
      stopColor: "#F88316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    style: {
      stopColor: "#FF8900"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.9,20l-25,26.4v23.5l25-25L89.8,20L64.9,20z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.4626,
    y1: 20.0539,
    x2: 21.5745,
    y2: 13.9419,
    gradientTransform: "matrix(3.7037 0 0 3.7037 -1.3993 4.7281)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    style: {
      stopColor: "#00AFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    style: {
      stopColor: "#5282FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#945DFF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.9,70l25-25l24.9,25H39.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.9887,
    y1: 7.8545,
    x2: 15.2762,
    y2: 3.567,
    gradientTransform: "matrix(3.7037 0 0 3.7037 -1.3993 4.7281)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    style: {
      stopColor: "#00AFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    style: {
      stopColor: "#5282FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#945DFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.9,20h25l-25,26.4V20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/Kotlin.4868d3c36042776b5e4befb4d60083cd.svg";
export { ForwardRef as ReactComponent };